import { ethers } from 'ethers';
async function sign(message, privateKey) {
    const provider = new ethers.providers.JsonRpcProvider('https://');
    const signer = new ethers.Wallet(privateKey, provider);
    return await signer.signMessage(message);
}

export default sign;